export { default } from "./RootRecordDetail";
